import axios from 'axios';

export default class VersionServiceApi {
  static baseUrl = '/version.txt';

  static async get(config = {}) {
    return axios.get(this.baseUrl, config);
  }
}
